export enum MassActionType {
  TO_REJECT = 'TO_REJECT',
  TO_APPROVE = 'TO_APPROVE',
  TO_APPROVE_REJECT = 'TO_APPROVE_REJECT',
  APPROVE_REJECTED = 'APPROVE_REJECTED',
  APPROVE_PAYMENT = 'APPROVE_PAYMENT',
  APPROVE_PAYMENT_REJECTED = 'APPROVE_PAYMENT_REJECTED',
}
